import { render, staticRenderFns } from "./temp.vue?vue&type=template&id=8910c82e&scoped=true"
import script from "./temp.vue?vue&type=script&lang=js"
export * from "./temp.vue?vue&type=script&lang=js"
import style0 from "./temp.vue?vue&type=style&index=0&id=8910c82e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8910c82e",
  null
  
)

export default component.exports